import React, { useState, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { translations } from './data/translations';

// --- استيراد المكونات ---
import Header from './components/Header';
import VisionValues from './components/VisionValues'; 
// استيراد المكون الجديد بدلاً من ProductShop القديم
import BrandsPage from './pages/BrandsPage'; 
import Footer from './components/Footer';
import ProjectsSection from './components/ProjectsSection';
import SocialSidebar from './components/SocialSidebar'; 
import Testimonials from './components/Testimonials';
import CompanyHighlights from './components/CompanyHighlights'; 

// استيراد مكونات الإدارة
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminAddProduct from './components/AdminAddProduct';

// --- استيراد الصفحات ---
import Hero from './pages/Hero';
import About from './pages/About'; 
import OurStory from './pages/OurStory'; 
import Brands from './pages/Brands'; 
import Store from './pages/ExportSection'; // هذا هو قسم التصدير
import Contact from './pages/Contact';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem('isAdmin') === 'true';
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  const [lang, setLang] = useState('ar');
  const t = useMemo(() => {
    const data = translations[lang];
    return data?.default ? data.default : data;
  }, [lang]);

  const HomePage = () => (
    <div style={{ 
      direction: lang === 'ar' ? 'rtl' : 'ltr', 
      backgroundColor: '#f9f9f9',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <Header lang={lang} setLang={setLang} t={t} />
      
      <div id="home"><Hero t={t} lang={lang} /></div>
      <div id="about"><About t={t} lang={lang} /></div>
      <div id="our-story"><OurStory lang={lang} /></div>
      <div id="brands"><Brands lang={lang} /></div>
      
      <CompanyHighlights lang={lang} />
      <VisionValues lang={lang} />
      
      {/* تم فصل التصدير عن المتجر هنا */}
      <div id="export">
        <Store t={t} lang={lang} />
      </div>

      {/* استبدال المتجر القديم بصفحة الماركات الذكية التي أنشأناها */}
      <div id="yam-store-view">
        <BrandsPage lang={lang} />
      </div>

      <div id="projects">
        <ProjectsSection lang={lang} />
      </div>

      <div id="testimonials"><Testimonials t={t} lang={lang} /></div>
      <div id="contact"><Contact t={t} lang={lang} /></div>
      
      <SocialSidebar lang={lang} /> 
      <Footer t={t} lang={lang} />
    </div>
  );

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin-dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin-add-product" element={<ProtectedRoute><AdminAddProduct /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;